import React from 'react';
import { format } from 'date-fns';
import { Col, Row, Modal, ModalBody, ModalHeader } from '../../components/Bootstrap';
import { BigNumber } from '../../components/BigNumber';
import numberFormatter from '../../utils/numberFormatter';
import { DashboardQuery } from './__generated__/DashboardQuery';
import './Home.scss';
import { LiveSales } from './LiveSales';
import { RevenueGraph } from './RevenueGraph';
import { TopCategories } from './TopCategories';
import { TopSellingDrinks } from './TopSellingDrinks';
import { AcknowledgeUpdatesVariables } from './__generated__/AcknowledgeUpdates';

interface AcknowledgeUpdatesParams {
  variables: AcknowledgeUpdatesVariables;
}

interface HomeProps {
  data?: DashboardQuery;
  loading: boolean;
  error?: Error;
  start: Date;
  end: Date;
  interval: string;
  onChangeInterval(interval: string);
  acknowledgeUpdates(params: AcknowledgeUpdatesParams);
}

interface HomeState {
  notificationModalOpen: boolean;
}

export class Home extends React.Component<HomeProps, HomeState> {
  constructor(props: HomeProps) {
    super(props);

    this.state = {
      notificationModalOpen: props.data ? props.data.productUpdates.length > 0 : false,
    };
  }

  componentDidUpdate(props: HomeProps) {
    if (props.data !== this.props.data) {
      this.setState({
        notificationModalOpen: this.props.data ? this.props.data.productUpdates.length > 0 : false,
      });
    }
  }

  toggle = async () => {
    this.props.acknowledgeUpdates({
      variables: {
        updateIds: this.props.data.productUpdates.map((update) => update.id),
      },
    });

    this.setState({ notificationModalOpen: !this.state.notificationModalOpen });
  };

  render() {
    if (this.props.loading || !this.props.data) {
      return <div className='text-center'>Loading...</div>;
    }

    const { data } = this.props;
    const { dashboardStats } = data;
    const { revenue, drinks, categories, tips, users, todaysSales } = dashboardStats;

    return (
      <div className='dashboard-container'>
        <RevenueGraph revenue={revenue} interval={this.props.interval} changeInterval={this.props.onChangeInterval} />
        <Row>
          <Col md={6} xs={12}>
            <TopSellingDrinks data={drinks} />
          </Col>
          <Col md={6}>
            <TopCategories categories={categories} />
            <Row className='h-50-full'>
              <Col md={6} xs={12}>
                <LiveSales
                  acceptedSales={todaysSales.accepted}
                  nonAcceptedSales={todaysSales.nonAccepted}
                  preorderSales={todaysSales.preorders}
                />
              </Col>
              <Col md={6}>
                <BigNumber className='border-left-0 h-100-full' title='Unique Users' data={numberFormatter(users)} />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md={3} xs={12}>
            <BigNumber
              className='total-tips border-top-0 border-left-0'
              title='Total Tips'
              data={`$${numberFormatter(tips)}`}
            />
          </Col>
        </Row>
        <Modal
          className='user-management-modal'
          size='sm'
          isOpen={this.state.notificationModalOpen}
          toggle={this.toggle}
        >
          <ModalHeader className='pb-0'>What's New</ModalHeader>
          <ModalBody className='pt-1'>
            {this.props.data.productUpdates.map((update) => (
              <div key={update.id}>
                <p className='product-update-date'>{format(new Date(update.releaseDate), 'MMMM do')}</p>
                <p dangerouslySetInnerHTML={{ __html: update.releaseNotes }} />
              </div>
            ))}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
